const enUS={decimal:'.',thousands:',',grouping:[3],prefix:'$',suffix:''};export default enUS;


//////////////////
// WEBPACK FOOTER
// ./node_modules/fusioncharts/vendors/fc-utils/src/number-converter/locales/en-US.js
// module id = OJQJ
// module chunks = 1